import React from "react";
import Popupz from "../atoms/Popupz";
import Inputz from "../atoms/Inputz";
import Buttonz from "../atoms/Buttonz";
import SvgIcn from "../../data/IconCompo";
import Staticz from "../atoms/Staticz";
import About from "../compoC/AboutC";
import Policy from "../compoC/PolicyC";
import Contact from "../compoC/ContactC";
import ValidationPopup from "../compoC/popups/ValidationPopup";
import SignupPopup from "../compoC/popups/SignupPopup";
import SignupExpiredPopup from "../compoC/popups/SignupExpiredPopup";
import CongratsPopup from "../compoC/popups/CongratsPopup";
import ForgotPasswordPopup from "../compoC/popups/ForgotPasswordPopup";
import CheckEmailPopup from "../compoC/popups/CheckEmailPopup";
import ResetPasswordPopup from "../compoC/popups/ResetPasswordPopup";
import PasswordResetSuccessPopup from "../compoC/popups/PasswordResetSuccessPopup";
import { useDispatch, useSelector } from "react-redux";
import LoginPopup from "../compoC/LoginPopup";
import {
  showCheckEmailPopup,
  hideForgotPasswordPopup,
  hideCheckEmailPopup,
  hideResetPasswordPopup,
  showPasswordResetSuccessPopup,
  hidePasswordResetSuccessPopup,
  hidePopup,
} from "../../redux/actions";
import {
  SettingEditPopup,
  SettingEmailPopup,
  SettingPasswordPopup,
} from "../compoC/popups/SettingPopups";

const AllPopups = ({ activePopupId, onClose }) => {
  const { validationPopup, Popup, forgotPasswordAndCheckEmail, resetPassword } =
    useSelector((state) => state);
  const dispatch = useDispatch();

  /** Redux + Top page `activePopupId` must both clear or Popupz stays mounted with isOpen false. */
  const closeStaticPopup = () => {
    dispatch(hidePopup());
    if (typeof onClose === "function") onClose();
  };

  const handleForgotPasswordSuccess = () => {
    dispatch(hideForgotPasswordPopup());
    dispatch(showCheckEmailPopup());
  };

  const handleResetPasswordSuccess = () => {
    dispatch(hideResetPasswordPopup());
    dispatch(showPasswordResetSuccessPopup());
  };

  return (
    <div>
      {/* - - - - - - - - SIGNUP POPUP - - - - - - - - */}
      {Popup === "signup" && <SignupPopup onClose={() => dispatch(hidePopup())} />}
      {/* - - - - - - - - SIGNUP LINK EXPIRED POPUP - - - - - - - - */}
      {Popup === "signupExpired" && <SignupExpiredPopup />}
      {/* - - - - - - - - LOGIN POPUP - - - - - - - - */}
      {Popup === "login" && <LoginPopup onClose={() => dispatch(hidePopup())} />}
      {/* - - - - - - - - FORGOT PASSWORD POPUP - - - - - - - - */}
      {forgotPasswordAndCheckEmail.forgotPasswordPopup && (
        <ForgotPasswordPopup
          onClose={() => dispatch(hideForgotPasswordPopup())}
          onSuccess={handleForgotPasswordSuccess}
        />
      )}
      {/* - - - - - - - - CHECK EMAIL POPUP - - - - - - - - */}
      {forgotPasswordAndCheckEmail.checkEmailPopup && (
        <CheckEmailPopup onClose={() => dispatch(hideCheckEmailPopup())} />
      )}
      {/* - - - - - - - - RESET PASSWORD POPUP - - - - - - - - */}
      {resetPassword.resetPasswordPopup && (
        <ResetPasswordPopup
          onClose={() => dispatch(hideResetPasswordPopup())}
          onSuccess={handleResetPasswordSuccess}
          resetToken={resetPassword.resetToken}
          resetId={resetPassword.resetId}
        />
      )}
      {/* - - - - - - - - PASSWORD RESET SUCCESS POPUP - - - - - - - - */}
      {resetPassword.successPopup && (
        <PasswordResetSuccessPopup
          onClose={() => dispatch(hidePasswordResetSuccessPopup())}
        />
      )}
      {Popup == "settingEdit" && <SettingEditPopup onClose={() => dispatch(hidePopup())} />}
      {Popup == "settingEmail" && <SettingEmailPopup onClose={() => dispatch(hidePopup())} />}
      {Popup == "settingPassword" && (
        <SettingPasswordPopup onClose={() => dispatch(hidePopup())} />
      )}

      {/* - - - - - - - - ABOUT POPUP - - - - - - - - */}
      {(activePopupId === "about" || Popup === "about") && (
        <Popupz onClose={closeStaticPopup} className="static-popup about">
          <About />
        </Popupz>
      )}
      {/* - - - - - - - - CONTACT POPUP - - - - - - - - */}
      {(activePopupId === "contact" || Popup === "contact") && (
        <Popupz onClose={closeStaticPopup} className="static-popup larger">
          <Contact />
        </Popupz>
      )}
      {/* - - - - - - - - Policy POPUP - - - - - - - - */}
      {(activePopupId === "policy" || Popup === "policy") && (
        <Popupz onClose={closeStaticPopup} className="static-popup about">
          <Policy />
        </Popupz>
      )}

      {/* - - - - - - - - VALIDATION POPUP - - - - - - - - */}
      {validationPopup && (
        <ValidationPopup
          text={validationPopup.message}
          icon={validationPopup.icon}
          type={validationPopup.type}
        />
      )}
      {/* - - - - - - - - CONGRATS POPUP - - - - - - - - */}
      {Popup == "congrats" && <CongratsPopup />}
    </div>
  );
};

export default AllPopups;
